import { MultiSelect, MultiSelectChangeEvent } from "primereact/multiselect";
import { GradingAreaMapping } from "../../config/GradingAreaMapping";
import { useCallback, useMemo } from "react";
import { ColumnFilterElementTemplateOptions } from "primereact/column";

export const GradingAreaFilter = (options: ColumnFilterElementTemplateOptions) => {
    const gradingAreaOptions = useMemo(() => (
        Object.keys(GradingAreaMapping).map((key) => ({ label: GradingAreaMapping[key], value: key }))
    ), []);

    const onChange = useCallback((event: MultiSelectChangeEvent) => (
        options.filterApplyCallback(event.value)
    ), [options]);

    return (
        <MultiSelect
            value={options.value}
            options={gradingAreaOptions}
            onChange={onChange}
            filter
            showClear
            placeholder="Show all"
            scrollHeight="400px"
            className="large-filter"
        />
    );
};

